import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import moment from "moment";
import RadioInput from "./RadioInput";
import WizardFooter from "./WizardFooter";
import SignatureModal from "./SignatureModal";
import { felonyConsideration } from "../utils/surveyLogic";

export const fields = [
  "first_name",
  "last_name",
  "ssn",
  "birthMonth",
  "birthDay",
  "birthYear",
  "email",
  "phone",
  "street",
  "city",
  "county",
  "state",
  "zip",
  "worked_for_us_before",
  "is_veteran",
  "is_entitled_to_compensation",
  "dischargeMonth",
  "dischargeYear",
  "service_branch",
  "unemployed_four_weeks",
  "unemployed_six_months",
  "referred_by_vocal_rehab",
  "referred_by_ticket_to_work",
  "referred_by_veterans_affairs",
  "supplemental_security_income",
  "convicted_of_felony",
  "convictionMonth",
  "convictionYear",
  "releaseMonth",
  "releaseYear",
  "state_or_federal_conviction",
  "court_city_or_county",
  "conviction_state",
  "officer_name",
  "officer_phone",
  "work_release",
  "contact_felony",
  "snap_six_months",
  "tanf_three_years",
  "snap_one_year",
  "benefits_recipient",
  "benefits_city_and_state",
  "has_been_unemployed",
  "has_received_unemployment_compensation",
  "unemploymentStartMonth",
  "unemploymentStartDay",
  "unemploymentStartYear",
  "unemployment_state",
  "summary_signature",
  "summarySignatureDay",
  "summarySignatureMonth",
  "summarySignatureYear",
  "summary_signature_statement",
  "job_description",
  "starting_pay",
];

const validate = values => {
  const errors = {};
  if (!values.summary_signature) {
    errors.summary_signature = "Signature required";
  }
  return errors;
};

export class WizardFormSummary extends Component {
  state = {
    showSignature: false,
  };

  closeSignature = () => {
    this.setState({ showSignature: false });
  };

  openSignature = () => {
    this.setState({ showSignature: true });
  };

  getText = () => {
    const { allText } = this.props;
    return { ...allText.shared, ...allText.summary, ...allText };
  };

  render() {
    const {
      fields: {
        first_name,
        last_name,
        ssn,
        birthMonth,
        birthDay,
        birthYear,
        email,
        phone,
        street,
        city,
        county,
        state,
        zip,
        worked_for_us_before,
        is_veteran,
        is_entitled_to_compensation,
        dischargeMonth,
        dischargeYear,
        service_branch,
        unemployed_four_weeks,
        unemployed_six_months,
        referred_by_vocal_rehab,
        referred_by_ticket_to_work,
        referred_by_veterans_affairs,
        supplemental_security_income,
        convicted_of_felony,
        convictionMonth,
        convictionYear,
        releaseMonth,
        releaseYear,
        state_or_federal_conviction,
        court_city_or_county,
        conviction_state,
        officer_name,
        officer_phone,
        work_release,
        contact_felony,
        snap_six_months,
        tanf_three_years,
        snap_one_year,
        benefits_recipient,
        benefits_city_and_state,
        has_been_unemployed,
        has_received_unemployment_compensation,
        unemploymentStartMonth,
        unemploymentStartDay,
        unemploymentStartYear,
        unemployment_state,
        summary_signature,
        summarySignatureDay,
        summarySignatureMonth,
        summarySignatureYear,
        summary_signature_statement,
        job_description,
        starting_pay,
      },
      handleSubmit,
      previousPage,
    } = this.props;
    const text = this.getText();
    const progress = 0;
    const hasUnemploymentDuration =
      has_been_unemployed.value === "true" &&
      has_received_unemployment_compensation.value === "true";
    const birthMoment = moment(
      `${birthYear.value}-${birthMonth.value}-${birthDay.value}`
    );
    const dischargeMoment = moment(
      `${dischargeYear.value}-${dischargeMonth.value}-01`
    );
    const convictionMoment = moment(
      `${convictionYear.value}-${convictionMonth.value}-01`
    );
    const releaseMoment = moment(
      `${releaseYear.value}-${releaseMonth.value}-01`
    );
    const unemploymentStartMoment = moment(
      `${unemploymentStartYear.value}-${unemploymentStartMonth.value}-${
        unemploymentStartDay.value
      }`
    );
    const dischargeDisplay =
      is_veteran.value === "yes"
        ? dischargeMoment.format("MMM YYYY").toString()
        : null;
    const convictionDisplay =
      convicted_of_felony.value === "yes"
        ? convictionMoment.format("MMM YYYY").toString()
        : null;
    const releaseDisplay =
      convicted_of_felony.value === "yes"
        ? releaseMoment.format("MMM YYYY").toString()
        : null;
    const unemploymentStartDisplay = hasUnemploymentDuration
      ? unemploymentStartMoment.format("MMM D, YYYY").toString()
      : null;

    const is_veteranInactiveClass =
      is_veteran.value === "yes" ? null : "inactive";

    const felonyDatesInactiveClass =
      convicted_of_felony.value === "yes" ? null : "inactive";

    const felonyInfoInactiveClass = felonyConsideration({
      convicted_of_felony: convicted_of_felony.value,
      convictionMonth: convictionMonth.value,
      convictionYear: convictionYear.value,
      releaseMonth: releaseMonth.value,
      releaseYear: releaseYear.value,
    })
      ? null
      : "inactive";

    const isBenefits =
      snap_six_months.value === "yes" ||
      tanf_three_years.value === "yes" ||
      snap_one_year.value === "yes";
    const benefitsInactiveClass = isBenefits ? null : "inactive";
    const unemploymentDurationInactiveClass = hasUnemploymentDuration
      ? null
      : "inactive";
    return (
      <form onSubmit={handleSubmit} className="form-horizontal summary-form">
        <div className="wizard-page-content summary">
          <div className="page-title-container">
            <div className="page-title summary-title">{text.title}</div>
            <div className="short-line" />
          </div>

          <div className="wizard-text big">
            <strong>{text.employeeInformation}</strong>
          </div>

          <div className="row employee-info-summary">
            <div className="col-sm-6 col-lg-4">
              <div>
                <div>
                  <div>{text.info01.name}</div>
                  <div id="full_name">
                    {first_name.value} {last_name.value}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-lg-4">
              <div>
                <div>
                  <div>{text.info01.ssn}</div>
                  <div>{ssn.value}</div>
                </div>
              </div>
            </div>

            <div className="col-md-5 col-lg-4">
              <div>
                <div id="worked_for_us_before">
                  <div>{text.info02.workedForUsBefore}</div>
                  {(worked_for_us_before.value === "yes" && (
                    <div>
                      {"Yes"}
                      <span className="weak">{" / No"}</span>
                    </div>
                  )) || (
                    <div>
                      <span className="weak">{"Yes / "}</span>
                      {"No"}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-7 col-lg-6">
              <div>
                <div>
                  <div>{text.info02.street}</div>
                  <div>{street.value}</div>
                </div>
              </div>
            </div>

            <div className="clearfix visible-sm-block" />

            <div className="col-12 col-sm-6 col-md-3">
              <div>
                <div>
                  <div>{text.info02.city}</div>
                  <div>{city.value}</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-3">
              <div>
                <div>
                  <div>{text.info02.county}</div>
                  <div>{county.value}</div>
                </div>
              </div>
            </div>

            <div className="col-6 col-sm-3 col-md-3">
              <div>
                <div>
                  <div>{text.info02.state}</div>
                  <div>{state.value}</div>
                </div>
              </div>
            </div>

            <div className="col-6 col-sm-3 col-md-3">
              <div>
                <div>
                  <div>{text.info02.zip}</div>
                  <div>{zip.value}</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-6">
              <div>
                <div>
                  <div>{text.info01.birthDate}</div>
                  <div className="test-dob">
                    {birthMoment.format("MMM D, YYYY")}
                  </div>
                </div>
              </div>
            </div>

            <div className="clearfix visible-md-block visible-lg-block" />

            <div className="col-12 col-sm-6 col-md-6">
              <div>
                <div>
                  <div>{text.info01.email}</div>
                  <div>{email.value}</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-6">
              <div>
                <div>
                  <div>{text.info01.phone}</div>
                  <div>{phone.value}</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-6">
              <div>
                <div>
                  <div>{text.info01.job_description}</div>
                  <div>{job_description.value}</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-6">
              <div>
                <div>
                  <div>{text.info01.starting_pay}</div>
                  <div>{starting_pay.value}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-sm-6 section-column">
              <div className="cutout">
                <div className="row">
                  <div className="col-1 question-number">{"1."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section01.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={is_veteran}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={is_veteranInactiveClass}>
                      <div>
                        <div>{text.section01.question01}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={is_entitled_to_compensation}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={is_veteranInactiveClass}>
                      <div>
                        <div>{text.section01.question02}</div>
                        <div className="ul">{dischargeDisplay}</div>
                      </div>
                    </div>
                    <div className={is_veteranInactiveClass}>
                      <div>
                        <div>{text.section01.question03}</div>
                        <div className="ul">{service_branch.value}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number">{"2."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section02.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={unemployed_four_weeks}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number">{"3."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section03.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={unemployed_six_months}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number">{"4."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section04.primaryQuestion}</div>
                        <div />
                      </div>
                    </div>
                    <div>
                      <div>
                        <div>{text.section04.question01}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={referred_by_vocal_rehab}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div>{text.section04.question02}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={referred_by_ticket_to_work}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div>{text.section04.question03}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={referred_by_veterans_affairs}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number">{"5."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section05.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={supplemental_security_income}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number">{"6."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section06.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={convicted_of_felony}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={felonyDatesInactiveClass}>
                      <div>
                        <div>{text.section06.question01}</div>
                        <div className="ul">{convictionDisplay}</div>
                      </div>
                    </div>
                    <div className={felonyDatesInactiveClass}>
                      <div>
                        <div>{text.section06.question02}</div>
                        <div className="ul">{releaseDisplay}</div>
                      </div>
                    </div>
                    <div className={felonyInfoInactiveClass}>
                      <div>
                        <div>{text.section06b.question04}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={state_or_federal_conviction}
                            options={["state", "federal"]}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={felonyInfoInactiveClass}>
                      <div>
                        <div>{text.section06b.question05}</div>
                        <div className="ul">{court_city_or_county.value}</div>
                      </div>
                    </div>
                    <div className={felonyInfoInactiveClass}>
                      <div>
                        <div>{text.section06b.question06}</div>
                        <div className="ul">{conviction_state.value}</div>
                      </div>
                    </div>
                    <div className={felonyInfoInactiveClass}>
                      <div>
                        <div>{text.section06c.question07}</div>
                        <div className="ul">{officer_name.value}</div>
                      </div>
                    </div>
                    <div className={felonyInfoInactiveClass}>
                      <div>
                        <div>{text.section06c.question08}</div>
                        <div className="ul">{officer_phone.value}</div>
                      </div>
                    </div>
                    <div className={felonyInfoInactiveClass}>
                      <div>
                        <div>{text.section06c.question09}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={work_release}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div>{text.section06c.question10}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={contact_felony}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 section-column">
              <div className="cutout bordered">
                <div className="row">
                  <div className="col-1 question-number">{"7."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section07.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={snap_six_months}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number">{"8."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section08.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={tanf_three_years}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number">{"9."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section09.primaryQuestion}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={snap_one_year}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-1 question-number" />
                  <div className="col-11">
                    <div className={benefitsInactiveClass}>
                      <div>
                        <div className="tiny">
                          {text.section09b.summaryQuestion}
                        </div>
                        <div />
                      </div>
                    </div>
                    <div className={benefitsInactiveClass}>
                      <div>
                        <div>{text.section09b.question01}</div>
                        <div className="ul">{benefits_recipient.value}</div>
                      </div>
                    </div>
                    <div className={benefitsInactiveClass}>
                      <div>
                        <div>{text.section09b.question02}</div>
                        <div className="ul">
                          {benefits_city_and_state.value}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cutout">
                <div className="row">
                  <div className="col-1 question-number">{"10."}</div>
                  <div className="col-11">
                    <div>
                      <div>
                        <div>{text.section10.primaryQuestion}</div>
                        <div />
                      </div>
                    </div>
                    <div>
                      <div>
                        <div>{text.section10.question01}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={has_been_unemployed}
                            options={["true", "false"]}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div>{text.section10.question02}</div>
                        <div className="dotted" />
                        <div>
                          <RadioInput
                            text={text}
                            field={has_received_unemployment_compensation}
                            options={["true", "false"]}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className={unemploymentDurationInactiveClass}>
                      <div>
                        <div>{text.section10.unemploymentStart}</div>
                        <div className="ul">{unemploymentStartDisplay}</div>
                      </div>
                    </div>
                    <div className={unemploymentDurationInactiveClass}>
                      <div>
                        <div>{text.section10.unemployment_state}</div>
                        <div className="ul">{unemployment_state.value}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <WizardFooter
          text={text}
          previousPage={previousPage}
          nextPage={this.openSignature}
          progress={progress}
          previousLabel={text.edit}
          nextLabel={text.sign}
          max={3}
          what={text.signed}
        />
        <SignatureModal
          showSignature={this.state.showSignature}
          openSignature={this.openSignature}
          closeSignature={this.closeSignature}
          handleSubmit={handleSubmit}
          signatureField={summary_signature}
          signatureDay={summarySignatureDay}
          signatureMonth={summarySignatureMonth}
          signatureYear={summarySignatureYear}
          signatureStatement={summary_signature_statement}
          text={text}
          formText={text}
        />
      </form>
    );
  }
}

WizardFormSummary.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSummary);



// WEBPACK FOOTER //
// ./src/components/WizardFormSummary.js